import React from 'react';
import { Link } from 'react-router-dom';

const mockFavorites = [
  { id: '1', eo_number: 'EO-1426', title: 'Постановление Правительства РФ от 26.12.1994 № 1426', authority: 'Правительство РФ', doc_date: '1994-12-26', status: 'active' },
  { id: '2', eo_number: 'EO-116-ФЗ', title: 'Федеральный закон от 21.07.1997 № 116-ФЗ', authority: 'Госдума', doc_date: '1997-07-21', status: 'repealed' },
];

export const FavoritesPage: React.FC = () => {
  return (
    <div>
      <h4 className="fw-bold mb-4">Избранное</h4>
      <div className="table-card">
        <div className="table-responsive">
          <table className="table mb-0">
            <thead>
              <tr>
                <th>№ EO</th>
                <th>Название</th>
                <th>Орган</th>
                <th>Дата</th>
                <th>Статус</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {mockFavorites.map((doc) => (
                <tr key={doc.id}>
                  <td className="font-monospace">{doc.eo_number}</td>
                  <td><Link to={`/document/${doc.id}`} className="text-decoration-none fw-medium">{doc.title}</Link></td>
                  <td>{doc.authority}</td>
                  <td>{doc.doc_date}</td>
                  <td>
                    <span className={`badge-status badge-${doc.status}`}>
                      {doc.status === 'active' ? 'Действует' : doc.status === 'amended' ? 'Изменён' : 'Утратил силу'}
                    </span>
                  </td>
                  <td>
                    <button className="btn btn-sm btn-link text-danger"><i className="bi bi-trash"></i></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
